export default __webpack_public_path__ + "static/media/noimage.1c01c829.png";